import axios from "axios";
import { setAuthHeader } from "app/services/auth.header.service";
import {
  getUrlForActiveClientProjectsByClient,
  getUrlForAddClientProject,
  getUrlForAllClientProjects,
  getUrlForClientProjectsByClient,
  getUrlForUpdateClientProject,
} from "utils/endpointUtils/clientProjectsEndpointUtil";

/**
 * Client project master data calls, mirroring the activity-type functions in admin.service.js
 * (axios plus setAuthHeader, so app.error.handler sees the same error shape).
 *
 * Deliberately separate from project.service.js, which talks to the phase-2 project-service
 * about a different kind of project.
 *
 * @since NEXT_VERSION
 */

const authConfig = () => {
  const config = setAuthHeader();
  if (config === null) throw new Error("Invalid Auth Header or Token Expired");
  return config;
};

/** @since NEXT_VERSION */
export const loadAllClientProjects = async () =>
  axios.get(getUrlForAllClientProjects(), authConfig());

/**
 * Active projects for one client, for the Add Activity dropdown.
 *
 * @since NEXT_VERSION
 */
export const loadActiveClientProjectsByClient = async (clientId) =>
  axios.get(getUrlForActiveClientProjectsByClient(clientId), authConfig());

/**
 * Every project for one client, deactivated ones included.
 *
 * @since NEXT_VERSION
 */
export const loadClientProjectsByClient = async (clientId) =>
  axios.get(getUrlForClientProjectsByClient(clientId), authConfig());

/** @since NEXT_VERSION */
export const addClientProjectToBackend = async (projectObject) =>
  axios.post(getUrlForAddClientProject(), projectObject, authConfig());

/** @since NEXT_VERSION */
export const updateClientProjectToBackend = async (id, projectObject) =>
  axios.put(getUrlForUpdateClientProject(id), projectObject, authConfig());

